define('suggestions-view',['controller'], function(controller) {
	function toggleReviews() {
		var button = $(this);
		var referencesText = $(this).parent();
		$('#review-list').toggle();
		button.toggleClass("icon-caret-down");
		button.toggleClass("icon-caret-up");
	}
	
	function toggleBaseRevision() {
		$('.suggestion-for-old-version-text').toggleClass('relevant');
		$('.suggestion-for-old-version-last-warning').hide();
	}
	
	controller.on('suggestions/view', function() {
		$('#toggle-reviews-button').click(toggleReviews);
		$('.toggle-base-revision').click(toggleBaseRevision);
	});
});
